
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWifiIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 96,
  height: 96,
  viewBox: "0 0 44 44",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.996 34.836a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.994 18.334c4.369-.015 8.565 1.638 11.666 4.598.296.28.487.635.56 1.01.074.373.032.768-.136 1.132-.17.367-.45.663-.79.863a2.105 2.105 0 0 1-1.188.281 2.066 2.066 0 0 1-1.42-.585c-2.303-2.22-5.431-3.469-8.693-3.469-3.263 0-6.39 1.249-8.693 3.468a2.06 2.06 0 0 1-1.428.565 2.059 2.059 0 0 1-1.425-.563 1.875 1.875 0 0 1-.582-1.352c0-.49.195-.979.58-1.35 3.071-2.933 7.22-4.583 11.549-4.598Z",
  fill: "#000"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.99 9.167c6.858.018 13.432 2.632 18.296 7.278.378.36.592.85.592 1.362 0 .512-.214 1.002-.592 1.362a2.07 2.07 0 0 1-1.441.563 2.066 2.066 0 0 1-1.437-.562c-4.258-4.089-9.837-6.135-15.416-6.135-5.58 0-11.158 2.046-15.417 6.135a2.07 2.07 0 0 1-1.439.572 2.07 2.07 0 0 1-1.438-.572 1.885 1.885 0 0 1-.589-1.363c0-.493.197-.986.588-1.362 4.865-4.646 11.439-7.26 18.294-7.278Z",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"96\" height=\"96\" viewBox=\"0 0 44 44\" fill=\"none\">\r\n  <path d=\"M21.9964 34.8361C19.971 34.8361 18.3291 33.1942 18.3291 31.1688C18.3291 29.1434 19.971 27.5015 21.9964 27.5015C24.0218 27.5015 25.6637 29.1434 25.6637 31.1688C25.6637 33.1942 24.0218 34.8361 21.9964 34.8361Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M21.9939 18.3343C26.3626 18.3191 30.5592 19.9719 33.6604 22.9318C33.9563 23.2126 34.1469 23.5665 34.2207 23.9419C34.2942 24.3155 34.2518 24.7101 34.0837 25.0737C33.914 25.4407 33.6344 25.7374 33.2936 25.9372C32.9493 26.139 32.5424 26.242 32.106 26.2181C31.5723 26.2108 31.0627 26.0021 30.6866 25.6332C28.3828 23.413 25.255 22.1641 21.9926 22.1641C18.7301 22.1641 15.6024 23.413 13.2997 25.6321C12.9049 26.0095 12.3883 26.197 11.8723 26.197C11.3563 26.197 10.8398 26.0095 10.4465 25.6336C10.0597 25.2596 9.86499 24.7709 9.86499 24.2815C9.86499 23.7921 10.0597 23.3034 10.4447 22.9311C13.5164 19.9992 17.6655 18.3487 21.9939 18.3343Z\" fill=\"#000000\"/>\r\n  <path d=\"M21.9907 9.16711C28.8478 9.18463 35.4218 11.799 40.2865 16.4454C40.6642 16.8055 40.8781 17.2954 40.8781 17.8072C40.8781 18.3189 40.6642 18.8088 40.2865 19.1689C39.9044 19.5333 39.3868 19.7353 38.8448 19.7323C38.3069 19.7353 37.7894 19.5333 37.4082 19.1698C33.1495 15.081 27.5709 13.0355 21.9917 13.0355C16.4125 13.0355 10.8339 15.081 6.57504 19.17C6.17779 19.5519 5.65685 19.7416 5.13649 19.7416C4.61612 19.7416 4.09518 19.5519 3.69794 19.17C3.30646 18.7936 3.10937 18.3008 3.10938 17.8072C3.10937 17.3136 3.30646 16.8207 3.69708 16.4452C8.56157 11.799 15.1356 9.18463 21.9907 9.16711Z\" fill=\"#000000\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/wifi-icon.09f96cb7b8f3b49f588fd109da034eff.svg"),
        {
          React: SvgWifiIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      